import { Formik } from "formik";
import * as Yup from "yup";
import Modal from "../../designComponents/Modal";
import { AcceptButton, LabelText } from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";

type ValuesType = {
  taxPercentage: number;
};

const validationSchema = Yup.object().shape({
  taxPercentage: Yup.number()
    .typeError("Must be a number")
    .required("Number is required")
    .min(1, "Number cannot be less than 1")
    .max(100, "Number cannot be more than 100"),
});

function AddEditTaxPercentageTrade({
  isOpen,
  onClose,
  initialValues,
  handleSubmit,
  type = "Add",
}: {
  isOpen: boolean;
  onClose: () => void;
  initialValues: ValuesType;
  handleSubmit: (values: ValuesType) => void;
  type?: "Add" | "Edit";
}) {
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title={`${type} Tax Percentage`}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validationSchema}
      >
        {({
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
          handleBlur,
        }) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflowY: "auto",
                    maxHeight: 400,
                  }}
                >
                  <InputGroup>
                    <LabelText>Tax Percentage For Trade</LabelText>
                    <Input
                      type="number"
                      step="0.01" // allows decimal input
                      value={values.taxPercentage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setFieldValue(
                          "taxPercentage",
                          val === "" ? "" : parseFloat(val)
                        );
                      }}
                      onBlur={handleBlur("taxPercentage")}
                      placeholder="Enter Tax Percentage for Trade"
                    />
                    {touched.taxPercentage && errors.taxPercentage && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.taxPercentage}
                      </div>
                    )}
                  </InputGroup>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 20,
                }}
              >
                <AcceptButton onClick={() => handleSubmit()}>Save</AcceptButton>
              </div>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default AddEditTaxPercentageTrade;
